function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M11 7.5v9c0 .55-.45 1-1 1H7.5c-1.52 0-2.89-.62-3.89-1.61A5.547 5.547 0 012 12.22C1.88 9.08 4.62 6.5 7.77 6.5H10c.55 0 1 .45 1 1zm11 4.28c.13 3.15-2.61 5.72-5.76 5.72h-2.23c-.55 0-1-.45-1-1v-9c0-.55.45-1 1-1h2.5c1.52 0 2.89.62 3.89 1.61.93.95 1.54 2.24 1.6 3.67z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 12.75H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75z"
})));